(function () {
  function initHeroSlider(root) {
    var slides = root.querySelectorAll('[data-hero-slide]');
    var dots = root.querySelectorAll('[data-hero-dot]');
    var prevBtn = root.querySelector('[data-hero-prev]');
    var nextBtn = root.querySelector('[data-hero-next]');
    var track = root.querySelector('[data-hero-track]');
    var total = slides.length;
    var current = 0;
    var timer = null;

    if (total <= 1) return;

    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 6000;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');

      current = (index + total) % total;

      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function next() {
      goTo(current + 1);
    }

    function prev() {
      goTo(current - 1);
    }

    function startAutoplay() {
      if (!autoplay || reducedMotion) return;
      stopAutoplay();
      timer = setInterval(next, speed);
    }

    function stopAutoplay() {
      if (timer) clearInterval(timer);
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        startAutoplay();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        startAutoplay();
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-index'), 10));
        startAutoplay();
      });
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    // ---------- Swipe con el dedo ----------
    var swipeTarget = track || root;
    var startX = 0;
    var startY = 0;
    var isDragging = false;
    var SWIPE_THRESHOLD = 50; // píxeles mínimos para contar como swipe

    function onTouchStart(e) {
      var touch = e.touches[0];
      startX = touch.clientX;
      startY = touch.clientY;
      isDragging = true;
    }

    function onTouchMove(e) {
      if (!isDragging) return;
      var touch = e.touches[0];
      var diffX = touch.clientX - startX;
      var diffY = touch.clientY - startY;

      // Si el movimiento es más vertical que horizontal, dejamos que el usuario
      // scrollee la página normalmente en vez de interceptar el gesto.
      if (Math.abs(diffY) > Math.abs(diffX)) return;

      // Movimiento predominantemente horizontal: evitamos el scroll vertical
      // accidental de la página mientras el usuario desliza el slider.
      e.preventDefault();
    }

    function onTouchEnd(e) {
      if (!isDragging) return;
      isDragging = false;

      var touch = e.changedTouches[0];
      var diffX = touch.clientX - startX;
      var diffY = touch.clientY - startY;

      if (Math.abs(diffX) < SWIPE_THRESHOLD || Math.abs(diffX) < Math.abs(diffY)) return;

      if (diffX < 0) {
        next();
      } else {
        prev();
      }
      startAutoplay();
    }

    swipeTarget.addEventListener('touchstart', onTouchStart, { passive: true });
    swipeTarget.addEventListener('touchmove', onTouchMove, { passive: false });
    swipeTarget.addEventListener('touchend', onTouchEnd, { passive: true });

    startAutoplay();
  }

  document.querySelectorAll('[data-hero-slider]').forEach(initHeroSlider);
})();